"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _prefix = _interopRequireDefault(require("../prefix"));

var _keyCodes = _interopRequireDefault(require("../internal/utils/keyCodes"));

var _setValidDimension = require("../internal/utils/setValidDimension");

var _Button = _interopRequireDefault(require("../Button"));

var _IconKeyboardArrowDown = _interopRequireDefault(require("../Icons/IconKeyboardArrowDown"));

var _DropdownOption = _interopRequireDefault(require("./DropdownOption"));

var _useOutsideClick = _interopRequireDefault(require("../internal/hooks/useOutsideClick"));
/**
 * Button that reveals lists of choices when engaged
 */


var Dropdown = function Dropdown(_ref) {
  var ariaLabel = _ref["aria-label"],
      _ref$buttonStyle = _ref.buttonStyle,
      buttonStyle = _ref$buttonStyle === void 0 ? "primary" : _ref$buttonStyle,
      _ref$dropup = _ref.dropup,
      dropup = _ref$dropup === void 0 ? false : _ref$dropup,
      className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      _ref$displayCaret = _ref.displayCaret,
      displayCaret = _ref$displayCaret === void 0 ? true : _ref$displayCaret,
      htmlId = _ref.htmlId,
      icon = _ref.icon,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 600 : _ref$maxHeight,
      name = _ref.name,
      onKeyDown = _ref.onKeyDown,
      onOutsideClick = _ref.onOutsideClick,
      onToggle = _ref.onToggle,
      options = _ref.options,
      _ref$pullRight = _ref.pullRight,
      pullRight = _ref$pullRight === void 0 ? false : _ref$pullRight,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "default" : _ref$size,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["aria-label", "buttonStyle", "dropup", "className", "children", "disabled", "displayCaret", "htmlId", "icon", "maxHeight", "name", "onKeyDown", "onOutsideClick", "onToggle", "options", "pullRight", "size"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(-1),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  var dropdownRef = (0, _react.useRef)();
  var itemRefs = (0, _react.useRef)(options.map(function () {
    return (0, _react.createRef)();
  }));
  (0, _react.useEffect)(function () {
    // Resets itemRef array when dropdown options change
    options.forEach(function (option, i) {
      itemRefs.current[i] = (0, _react.createRef)();
    });
  }, [options]);

  var handleOutsideClick = function handleOutsideClick(event) {
    setActiveIndex(-1);
    setOpen(false);
    if (onOutsideClick) onOutsideClick(event);
  };

  (0, _useOutsideClick["default"])({
    condition: open,
    element: dropdownRef,
    handler: handleOutsideClick
  });

  var onItemFocus = function onItemFocus(event) {
    var index = event.currentTarget.dataset.index;
    setActiveIndex(index);
  };

  var focusNext = function focusNext() {
    var index = Number(activeIndex) + 1;
    var count = options.length - 1;
    if (index > count) index = 0;
    itemRefs.current[index].current.focus();
    setActiveIndex(index);
  };

  var focusPrev = function focusPrev() {
    var index = Number(activeIndex) - 1;
    if (index < 0) index = options.length - 1;
    itemRefs.current[index].current.focus();
    setActiveIndex(index);
  };

  var onButtonKeyDown = function onButtonKeyDown(event) {
    handleKeyDown(event);
    if (onKeyDown) onKeyDown({
      target: {
        name: name
      }
    }, event);
  };

  var handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case _keyCodes["default"].upArrow:
        event.preventDefault();
        focusPrev();
        break;

      case _keyCodes["default"].downArrow:
        event.preventDefault();
        setOpen(true);
        focusNext();
        break;

      case _keyCodes["default"].esc:
        event.preventDefault();
        toggleDropdown();
        break;

      default:
        break;
    }
  };

  var toggleDropdown = function toggleDropdown(event) {
    setActiveIndex(-1);
    var isOpen = !open;
    setOpen(isOpen);
    if (onToggle) onToggle({
      target: {
        name: name,
        isOpen: isOpen
      }
    }, event);
  };

  var onItemSelect = function onItemSelect(value, itemProps, event, onSelect) {
    setOpen(false);
    if (onSelect) onSelect({
      target: {
        name: name,
        value: value,
        itemProps: itemProps
      }
    }, event);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-label": ariaLabel,
    className: (0, _classnames["default"])(["".concat(_prefix["default"], "dropdown"), "".concat(_prefix["default"], "btn-group"), dropup && "".concat(_prefix["default"], "dropup"), pullRight && "pull-right", className]),
    id: htmlId,
    name: name,
    ref: dropdownRef
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({
    buttonStyle: buttonStyle,
    className: "".concat(_prefix["default"], "dropdown-toggle"),
    disabled: disabled,
    htmlId: "".concat(htmlId, "-selectButton"),
    icon: icon,
    onMouseDown: toggleDropdown,
    onKeyDown: onButtonKeyDown,
    size: size
  }, other), children && /*#__PURE__*/_react["default"].createElement("span", {
    className: "toggleBtn-text"
  }, children), displayCaret && /*#__PURE__*/_react["default"].createElement("span", {
    className: "caretIcon"
  }, /*#__PURE__*/_react["default"].createElement(_IconKeyboardArrowDown["default"], {
    htmlId: "".concat(htmlId, "-arrowDown")
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    "aria-labelledby": "dropdown",
    className: (0, _classnames["default"])(["".concat(_prefix["default"], "dropdown-menu"), open ? "show" : "hide"]),
    role: "menu",
    style: {
      maxHeight: (0, _setValidDimension.setValidDimension)(maxHeight)
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", null, options.map(function (_ref2, key) {
    var active = _ref2.active,
        className = _ref2.className,
        component = _ref2.component,
        disabled = _ref2.disabled,
        divider = _ref2.divider,
        itemProps = _ref2.itemProps,
        header = _ref2.header,
        label = _ref2.label,
        onSelect = _ref2.onSelect,
        value = _ref2.value;
    var itemKey = "".concat(htmlId, "-item-").concat(key);
    return /*#__PURE__*/_react["default"].createElement(_DropdownOption["default"], {
      active: active || activeIndex === key,
      callback: onSelect,
      eventKey: key,
      htmlId: "".concat(itemKey, "-").concat(value),
      innerRef: itemRefs.current[key],
      key: itemKey,
      onKeyDown: handleKeyDown,
      onFocus: onItemFocus,
      onSelect: onItemSelect,
      className: className,
      disabled: disabled,
      divider: divider,
      header: header,
      itemProps: itemProps,
      label: label,
      value: value
    }, component);
  }))));
};

var _default = Dropdown;
exports["default"] = _default;